<template>
  <div
    class="h-screen bg-gray-100 p-4 sm:p-8 flex flex-col items-center relative"
  >
    <div class="absolute top-4 left-4 lg:left-12">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        class="mr-4 cursor-pointer"
        @click="$router.go(-1)"
        style="fill: rgba(0, 0, 0, 1)"
      >
        <path
          d="M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"
        ></path>
      </svg>
    </div>
    <div class="w-full max-w-md bg-white mt-20 p-6 rounded-lg shadow-md">
      <h1 class="text-2xl font-bold text-center text-gray-700 mb-6">
        Générer un Code QR pour l'équipe
      </h1>

      <form @submit.prevent="handleSubmit">
        <!-- Champ Campagne ID -->
        <div class="mb-4">
          <label
            for="campagneId"
            class="block text-sm font-medium text-gray-600 mb-1"
          >
            ID de la Campagne
          </label>
          <input
            type="text"
            id="campagneId"
            v-model="campagneId"
            required
            placeholder="Entrez l'ID de la campagne"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <!-- Champ Nom de l'Équipe -->
        <div class="mb-6">
          <label
            for="teamName"
            class="block text-sm font-medium text-gray-600 mb-1"
          >
            Nom de l'Équipe
          </label>
          <input
            type="text"
            id="teamName"
            v-model="teamName"
            required
            placeholder="Entrez le nom de l'équipe"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <!-- Bouton Soumettre -->
        <button
          @click="createCode"
          type="submit"
          :disabled="isLoading"
          class="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="isLoading">Génération en cours...</span>
          <span v-else>Générer le QR Code</span>
        </button>

        <!-- Affichage des Erreurs -->
        <p v-if="errorMessage" class="mt-4 text-center text-red-600 text-sm">
          Erreur : {{ errorMessage }}
        </p>
      </form>
    </div>

    <!-- Modal pour afficher le QR Code -->
    <div
      v-if="qrCodeImageUrl"
      class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
    >
      <div
        class="bg-white p-6 rounded-lg shadow-xl max-w-xs w-full text-center relative"
      >
        <!-- Bouton Fermer -->
        <button
          @click="closeModal"
          class="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 class="text-xl font-semibold text-gray-800 mb-4">QR Code Généré</h2>
        <div class="mb-4 flex justify-center">
          <img
            :src="qrCodeImageUrl"
            alt="QR Code généré"
            class="max-w-full h-auto border border-gray-300"
          />
        </div>
        <p class="text-sm text-gray-600 mb-4">
          Équipe : <span class="font-medium">{{ teamName }}</span> <br />
          Campagne ID : <span class="font-medium">{{ campagneId }}</span>
        </p>

        <button
          @click="downloadQRCode(qrCodeImageUrl)"
          :disabled="isLoading"
          class="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
        >
          <span v-if="isLoading">Téléchargement...</span>
          <span v-else>Télécharger le QR Code</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { createQrCode } from "./API fonctiond/fonctions";

export default {
  data() {
    return {
      campagneId: this.$route.query.id,
      teamName: "",
      isLoading: false,
      errorMessage: "",
      qrCodeImageUrl: null,
    };
  },
  methods: {
    async createCode() {
      console.log(this.campagneId);
      console.log(this.teamName);
      this.isLoading = true;
      this.errorMessage = "";

      try {
        const response = await createQrCode({
          campagneId: this.campagneId,
          teamName: this.teamName,
        });
        console.log(response.data);

        // Utiliser les données du QR code reçues
        if (response.data && response.data.qrCodeData) {
          this.qrCodeImageUrl = response.data.qrCodeData; // Assigner l'URL base64 à qrCodeImageUrl
        } else {
          this.errorMessage = "Données de QR code non reçues";
        }
      } catch (error) {
        console.log(error);
        this.errorMessage = "Erreur lors de la génération du QR code";
      } finally {
        this.isLoading = false;
      }
    },
    downloadQRCode(imageUrl, fileName = "QRCode.png") {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.href = blobUrl;
          link.style.display = "none";
          link.download = fileName;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 100);
        })
        .catch((error) => {
          console.error("Erreur lors du téléchargement de l'image:", error);
        });
    },
    closeModal() {
      if (this.qrCodeImageUrl && this.qrCodeImageUrl.startsWith("blob:")) {
        URL.revokeObjectURL(this.qrCodeImageUrl);
        console.log("Blob URL révoquée.");
      }
      this.qrCodeImageUrl = null;
    },
  },
};
</script>
